import React, { useEffect } from "react";
import { Badge, Button, Card, Input, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";

import { withTranslation } from "react-i18next";
import { useState } from "react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSearchInput from "../../common/CustomSearchInput";
import { getColumnDetail } from "../../../helpers/utils";
import NoRecords from "../../common/NoRecords";
import DataTable from "react-data-table-component";
import Loader from "../../common/Loader";
import { getLotLists } from "../../../store/auctions/lotActions";
import { useParams } from "react-router-dom";
import { INITIAL_GET_LOTS_PAYLOAD } from "./Lots";
import i18next from "i18next";

const PublishLotModal = ({ isModalOpen, onCancel, onSave, loader, t }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [lotsPayload, setLotsPayload] = useState({
    ...INITIAL_GET_LOTS_PAYLOAD,
    filter: {
      ...INITIAL_GET_LOTS_PAYLOAD?.filter,
      auction: id,
      is_publish: false,
    },
  });

  useEffect(() => {
    if (isModalOpen) {
      setLotsPayload({
        ...INITIAL_GET_LOTS_PAYLOAD,
        filter: {
          ...INITIAL_GET_LOTS_PAYLOAD?.filter,
          auction: id,
          is_publish: false,
        },
      });
    }
  }, [isModalOpen]);

  const lotsData = useSelector((state) => state?.Auctions?.lots?.data);
  const totalItems = useSelector((state) => state?.Auctions?.lots?.total);

  // loader
  const [tableLoader, setTableLoader] = useState(true);

  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  // handle getting lots item
  const handleGetLotLists = useCallback(
    (lotsPayload) => {
      setTableLoader(true);
      dispatch(getLotLists(lotsPayload)).then((res) => {
        if (res) {
          //
        } else {
          //
        }
        setTableLoader(false);
      });
    },
    [dispatch]
  );

  useEffect(() => {
    if (id && isModalOpen) {
      handleGetLotLists(lotsPayload);
    } else {
      return;
    }
  }, [handleGetLotLists, lotsPayload, id, isModalOpen]);

  const handleSaveBtn = () => {
    onSave(isAllSelected, selectedRows, lotsPayload?.filter);
    handleModalClose();
  };

  const handleModalClose = () => {
    setSelectedRows([]);
    setIsAllSelected(false);
    onCancel();
  };

  // handle page change
  const handlePageChange = (value) => {
    setLotsPayload((prevState) => ({
      ...prevState,
      page: value,
    }));
  };

  // handle rows per page change
  const handleRowsPerPageChange = (value) => {
    setLotsPayload((prevState) => ({
      ...prevState,
      limit: value,
    }));
  };

  const handleRowSelection = (row) => {
    if (!isAllSelected) {
      if (selectedRows?.find((item) => item === row?.id)) {
        setSelectedRows((prevState) => [...prevState?.filter((item) => item !== row?.id)]);
      } else {
        setSelectedRows((prevState) => [...prevState, row?.id]);
      }
    }
  };

  // get item description -> artist, title, description
  const getItemDescription = (row) => {
    let description = [];
    if (row?.contract_item?.author?.id) description.push(row?.contract_item?.author?.description);

    if (i18next?.resolvedLanguage === "pt") {
      if (row?.contract_item?.title_pt) description.push(row?.contract_item?.title_pt);
      if (row?.contract_item?.description_pt) description.push(row?.contract_item?.description_pt);
    } else {
      if (row?.contract_item?.title_en) description.push(row?.contract_item?.title_en);
      if (row?.contract_item?.description_en) description.push(row?.contract_item?.description_en);
    }
    return description?.length > 0 ? description.join(", ") : "-";
  };

  const columns = [
    {
      name: (
        <div className="font-weight-bold fs-14 table-column-container py-4 d-flex flex-row justify-content-center">
          <Input
            type="checkbox"
            checked={isAllSelected}
            onChange={(event) => {
              setIsAllSelected(event.target.checked);
              setSelectedRows([]);
            }}
          />
        </div>
      ),
      selector: (row) => (
        <Input
          type="checkbox"
          disabled={isAllSelected}
          checked={isAllSelected || Boolean(selectedRows?.find((item) => item === row?.id))}
          onChange={(event) => {
            handleRowSelection(row);
          }}
        />
      ),
      width: "10%",
      center: true,
    },
    {
      name: (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          <div className="table-column-title mb-2">{`${t("common.description")}`}</div>
          <CustomSearchInput
            columnWise={true}
            columnSearchKey={getColumnDetail("custom_title_en__icontains", "custom_title_pt__icontains")}
            className="column-search-input"
            payload={lotsPayload}
            setPayload={setLotsPayload}
          />
        </div>
      ),
      selector: (row) => getItemDescription(row),
      width: "80%",
      wrap: true,
    },
  ];

  return (
    <Modal centered isOpen={isModalOpen} size="lg" toggle={handleModalClose} fade={false}>
      <ModalHeader className="lot-header w-100">
        <div className="d-flex w-100 flex-row justify-content-between">
          <span>{`${t("common.select")} ${t("common.lot")}`}</span>
          <div className="contain-header-right d-flex flex-row gap-2">
            {(isAllSelected && totalItems > 0) || selectedRows.length ? (
              <>
                <Button
                  color="info"
                  onClick={() => {
                    setSelectedRows([]);
                    setIsAllSelected(false);
                  }}
                  className="d-flex justify-content-center align-items-center"
                >
                  {`${t("common.deselect")}`}
                  <Badge color="dark" className="ms-1">
                    {selectedRows.length || totalItems}
                  </Badge>
                </Button>
              </>
            ) : null}
          </div>
        </div>
      </ModalHeader>
      <ModalBody
        className="subcard-table-container table-light"
        style={{ border: "0px", borderRadius: "5px", boxShadow: "2px" }}
      >
        <Card className="subcard-table-container table-light">
          {tableLoader ? <Loader /> : null}
          <DataTable
            fixedHeader
            pointerOnHover
            className="data-table"
            persistTableHead
            columns={columns}
            data={lotsData}
            pagination
            paginationServer
            paginationTotalRows={totalItems}
            noDataComponent={<NoRecords />}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onChangePage={handlePageChange}
            onRowClicked={(row) => {
              handleRowSelection(row);
            }}
            paginationComponentOptions={{
              rowsPerPageText: t("common.rowsPerPage"),
              rangeSeparatorText: t("common.rangeSeparator"),
            }}
          />
        </Card>
      </ModalBody>
      <ModalFooter>
        <Button
          color="dark"
          onClick={() => {
            handleModalClose();
          }}
          disabled={loader}
        >
          {t("common.cancel")}
        </Button>
        <Button
          color="primary"
          disabled={loader || (isAllSelected === false && selectedRows.length < 1) || totalItems < 1}
          className="btn-load d-flex"
          onClick={handleSaveBtn}
        >
          {loader ? (
            <span className="d-flex align-items-center ">
              <Spinner size="xs" className="flex-shrink-0">
                {t("common.loading")}...
              </Spinner>
            </span>
          ) : null}
          <span className={`flex-grow-1 ${loader ? "ms-2" : ""}`}>{`${t("common.select")}`}</span>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default withTranslation()(PublishLotModal);
